export class CalculationModelOverview {
  /**
* The ID of the entity.
*/
  id: number;

  /**
   * The country of the entity.
   */
  country?: string;

  /**
   * The name of the entity.
   */
  name: string;

  /**
   * The sector of the entity.
   */
  sector?: string;

  /**
   * The valuation method of the entity.
   */
  valuationMethod?: string;

  /**
   * The ID of the status associated with the entity.
   */
  statusId?: number;

  /**
   * The status of the entity.
   */
  status?: string;
}
